import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobContent } from '@/features/jobs/details/components/JobContent'
import { JobHeadingContainer } from '@/features/jobs/details/components/JobHeading/JobHeadingContainer'
import { NextStepContainer } from '@/features/jobs/details/components/NextStep/NextStepContainers'
import { JobSectionsContainer } from '@/features/jobs/details/components/JobSections/JobSectionsContainer'
import { JobDetailsRailContainer } from '@/features/jobs/details/components/JobDetailsRail/JobDetailsRailContainer'
import { ProgressionStepsDialogContainer } from '@/features/jobs/details/components/JobProgressionCard/ProgressionStepsDialog/ProgressionStepsDialogContainer'
import { DragAndDropOverlayContainer } from '@/features/jobs/details/components/DragAndDropOverlay/DragAndDropOverlayContainer'
import { RatingsNotificationBarContainer } from '@/features/jobs/details/ratings/components/RatingsNotificationBar/RatingsNotificationBarContainer'
import { useDocumentTitle } from '@/hooks/document-title'

export interface JobContentContainerProps {
  vm: JobDetailsViewModel
}

export const JobContentContainer = observer(function JobContentContainer({
  vm,
}: JobContentContainerProps) {
  useDocumentTitle(`${vm.job.workspace.name} | ${vm.job.displayName}`)

  return (
    <JobContent
      notifications={
        <RatingsNotificationBarContainer vm={vm.collaboratorsVm.ratingsVm} />
      }
      overlay={
        <DragAndDropOverlayContainer
          vm={vm.documentsVm.uploadBarVm}
          targetJob={vm.job}
          onView={
            vm.section === 'documents' ? undefined : vm.viewDocumentsSection
          }
        />
      }
      rail={vm.detailsOpen && <JobDetailsRailContainer vm={vm} />}
      dialogs={<ProgressionStepsDialogContainer vm={vm} />}
    >
      <JobHeadingContainer vm={vm} />
      <NextStepContainer vm={vm} />
      <JobSectionsContainer vm={vm} />
    </JobContent>
  )
})
